import React from 'react';

function FairPracticeCode() {
  return (
    <div className="about-us grievance-page">
      <div className="container grievance-container privacy">

        <div className="grievance-hero">
          <h1 className="grievance-title">Fair Practice Code</h1>
        </div>

        <div className="grievance-doc">

          <h3>1. Introduction</h3>
          <div className="about-us-content">
            <p>
              This Fair Practice Code is aimed to provide to all the stake holders, especially customers
              effective overview of practices followed in respect of the financial facilities and services
              offered by Ascend Bizcap Private Limited ("<strong>Ascend Capital</strong>") to its customers.
            </p>
          </div>

          <h3>2. Objectives</h3>
          <div className="about-us-content">
            <ul>
              <li>To promote good practices and ensure good practices in dealing with customers.</li>
              <li>To act fairly and reasonably in all the dealings with borrowers.</li>
              <li>To ensure compliance with legal norms in matters relating to recovery of advances.</li>
              <li>To strengthen mechanisms for redressal of customer grievances.</li>
              <li>The Company will make every attempt to ensure that its customers would have trouble-free experience in dealing with it.</li>
            </ul>
          </div>

          <h3>3. Applicability</h3>
          <div className="about-us-content">
            <p>
              The Company has adopted this Fair Practices Code ("the Code") and have implemented it. The
              Code applies to all categories of products and services offered by the Company (currently
              offered and which may be introduced in future).
            </p>
          </div>

          <h3>4. Applications for Loans and their Processing</h3>
          <div className="about-us-content">
            <p>
              <strong>4.1</strong> Loan application forms issued by the Company shall include necessary information,
              which affects the interest of the borrower so that he/she can do a meaningful comparison with
              the terms and conditions offered by other NBFCs and an informed decision can be taken by the
              borrower.
            </p>
            <p>
              <strong>4.2</strong> All communication will be made in a language understood by the
              customers/borrowers or in a vernacular language, wherever required.
            </p>
            <p>
              <strong>4.3</strong> The Company shall devise a system of giving acknowledgement for receipt of all
              loan applications. The time frame within which loan applications shall be disposed of shall also
              be indicated in the acknowledgement.
            </p>
            <p>
              <strong>4.4</strong> The loan application form shall indicate the documents required to be submitted
              along with the application form. The Company shall collect all necessary documents to comply
              with Know Your Customer Norms (KYC norms) of RBI.
            </p>
            <p>
              <strong>4.5</strong> If any additional details/documents are required, the Company shall intimate the
              borrowers immediately.
            </p>
          </div>

          <h3>5. Loan Appraisal and Terms &amp; Conditions</h3>
          <div className="about-us-content">
            <p>
              The Loan sanctioned along with the detailed terms and conditions shall be communicated by means
              of a Sanction Letter in the language understood by the borrower and obtain the consent of a
              borrower. The copy of the Sanction Letter to be maintained with the Branch/Head Office as record.
            </p>
            <p>
              <strong>5.1</strong> The Company shall conduct a due diligence on the credit worthiness of the
              borrower, which will be an important parameter for taking decision on processing of the
              application. The assessment would be in line with the Company's internal policies, norms and
              procedures in respect thereof.
            </p>
            <p>
              <strong>5.2</strong> The Company, upon approval of the loan, shall convey the applicant through an
              agreement cum sanction letter or otherwise indicating the amount of loan, annualized rate of
              interest including method of application along with the terms and conditions.
            </p>
            <p>
              <strong>5.3</strong> To ensure that the Customers are not charged excessive interest rate, the Company
              shall adopt interest rate model considering relevant factors such as cost of funds, margin &amp;
              risk premium and regulatory cap etc., duly approved by Board. The rate of interest and the
              approach for gradations of risk and rationale for charging different rate of interest to different
              categories of borrowers shall be disclosed to the borrower or customer in the application form
              and communicated explicitly in the sanction letter. The information published on the website
              shall be updated whenever there is a change in the rates of interest.
            </p>
            <p>
              <strong>5.4</strong> The Company shall obtain an acceptance from the borrower of the loan terms &amp;
              conditions as stipulated in Loan agreement and maintain a record of such acceptance. The Company
              shall furnish a copy of the loan agreement as understood by the borrowers along with all the
              enclosures quoted in the loan agreement to the borrowers.
            </p>
            <p>
              <strong>5.5</strong> Foreclosure charges are to be applied as per the regulatory directions issued
              from time to time.
            </p>
          </div>

          <h3>6. Disbursement of Loans Including Changes in Terms and Condition</h3>
          <div className="about-us-content">
            <p>
              <strong>6.1</strong> The Company shall give notice to all its borrowers of any change in the terms
              and conditions including disbursement schedule, interest rates, service charges, prepayment
              charges etc. Any changes to the above charges shall be made prospectively.
            </p>
            <p><strong>6.2 Penal Charges in Loan Accounts</strong></p>
            <ul>
              <li>The Company shall ensure that the penal charges for the late payment is mentioned in the agreement.</li>
              <li>There shall be no capitalisation of penal charges i.e., no further interest computed on such charges. However, this will not affect the normal procedures for compounding of interest in the loan account.</li>
              <li>The Company shall not introduce any additional component to the rate of interest in lieu of penal charges.</li>
              <li>The quantum of penal charges shall be reasonable and commensurate with the non-compliance of material terms and conditions of loan contract without being discriminatory within a particular loan/product category.</li>
              <li>The penal charges in case of loans sanctioned to 'individual borrowers, for purposes other than business', shall not be higher than the penal charges applicable to non-individual borrowers for similar non-compliance of material terms and conditions.</li>
              <li>Whenever reminders for non-compliance of material terms and conditions of loan are sent to borrowers, the applicable penal charges shall be communicated. Further, any instance of levy of penal charges and the reason therefor shall also be communicated.</li>
            </ul>
            <p>
              <strong>6.3</strong> Any decision to recall/accelerate payment or performance under the loan agreement
              shall be in consonance with the loan agreement.
            </p>
            <p>
              <strong>6.4</strong> All securities pertaining to the loan would be released on receipt of full and
              final payment of the loans, subject to any legitimate right or lien, and set-off for any other
              claim that the Company may have against the borrowers. If such right of set-off is to be
              exercised, the borrower shall be given notice about the same, with full particulars about the
              remaining claims and the conditions under which the Company is entitled to retain the securities
              until the relevant claim is settled/paid.
            </p>
          </div>

          <h3>7. Repossession</h3>
          <div className="about-us-content">
            <p>
              The Company has included the repossession clause in the loan agreement with the borrower that
              would be legally enforceable. To ensure transparency, the terms and conditions of the
              contract/loan agreement will include provisions regarding:
            </p>
            <ul>
              <li><strong>7.1</strong> Notice period before taking possession.</li>
              <li><strong>7.2</strong> Circumstances under which the notice period can be waived.</li>
              <li><strong>7.3</strong> The procedure for taking possession of the security.</li>
              <li><strong>7.4</strong> A provision regarding final chance to be given to the borrower for repayment of loan before the sale/auction of the asset.</li>
              <li><strong>7.5</strong> The procedure for giving repossession to the borrower.</li>
              <li><strong>7.6</strong> The procedure for sale/auction of the asset.</li>
            </ul>
          </div>

          <h3>8. Grievance Redressal Mechanism</h3>
          <div className="about-us-content">
            <p>
              The Company aims to provide best customer service and is consistently striving on creating a
              robust and efficient customer service platform. The Complaints/Grievances received from all
              stakeholders shall be handled by the Company in accordance with the Grievance Redressal Policy
              of the Company.
            </p>
            <p>
              <strong>8.1</strong> The Company would provide contact details basis which the customer can approach
              with the grievance. The communication can be via phone, email, or a letter to the Company's
              registered address.
            </p>
            <p>
              <strong>8.2</strong> If the customer is still dissatisfied with the resolution received, he or she
              may write to our Grievance Redressal Officer/Principal Nodal Officer.
            </p>
          </div>

          <h3>9. General Criteria</h3>
          <div className="about-us-content">
            <p>
              <strong>9.1</strong> The Company shall not interfere in the affairs of the borrower except for the
              purposes provided in the Loan Agreement unless new information not earlier disclosed by the
              borrower has come to the notice of the Company.
            </p>
            <p>
              <strong>9.2</strong> The Company shall keep personal client information strictly confidential.
            </p>
            <p>
              <strong>9.3</strong> The Company shall disclose client information to a third party only under the
              following conditions:
            </p>
            <ul>
              <li>Customer has been informed about such disclosure and permission has been obtained in writing.</li>
              <li>The party in question has been authorized by the client to obtain client information from the Company.</li>
              <li>It is Regulatory or legally required to do so.</li>
            </ul>
            <p>
              <strong>9.4</strong> In the matter of recovery of loans, the Company shall follow the usual measures
              as per the laid down guidelines and existing provisions and would operate within the legal
              framework and in compliance with the applicable laws and regulations.
            </p>
            <p>
              <strong>9.5</strong> The Company would not resort to undue harassment, viz., persistently bothering
              the borrowers at odd hours, use of muscle power for recovery of loans etc. In this regard, the
              Company has an established code of conduct for debt collection wherein the staff or any person
              authorized to represent the Company in collection of dues are extensively trained.
            </p>
            <p>
              <strong>9.6</strong> The Company's collection policy is built on courtesy, fair treatment and
              persuasion. The Company believes in customer confidence and long-term relationship. The
              Company's staff or any person authorized to represent us in collection of dues or/and security
              repossession will identify himself/herself and interact with our customers in a courteous manner.
            </p>
            <p>
              <strong>9.7</strong> The Company shall provide customers all the information regarding dues and shall
              give sufficient notice for payment of dues. All customers will be contacted ordinarily at the
              place of their choice, in the absence of a specified place at the residence of the customer and
              if the customer is unavailable at the residence, at the customer's place of business/occupation.
            </p>
            <p>
              <strong>9.8</strong> Whenever a request for transfer of loan account is received from a borrower,
              the Company shall respond to the same within 21 (twenty-one) days of receipt of request.
              Acceptance or refusal thereof shall be in accordance with terms of the loan agreement.
            </p>
            <p>
              <strong>9.9</strong> The Company is required to release all property documents upon receiving full
              repayment and closure of loan account. The procedure for covering the above aspects shall be
              displayed on the website of the Company.
            </p>
            <p>
              <strong>9.10</strong> The Company shall not discriminate in extending products and facilities
              including loan facilities to the physically/visually challenged applicants on the grounds of
              disability. They shall be treated at par with the other applicants and their application shall
              be dealt on merit as per the credit process and policy of the Company. All possible assistance
              will be provided to the applicants with the disability(ies) to enable them to understand, select
              and avail appropriate product or loan facility.
            </p>
            <p>
              <strong>9.11</strong> The Company shall ensure that its publicity and promotional literature and
              other materials are not misleading. In any advertisement and promotional literature that draws
              attention to a service or a product and includes a reference to an interest rate, the Company
              will indicate whether other fees and charges will apply, and shall disclose that the final
              sanction of the loan will be subject to fulfilment of the relevant terms and conditions.
            </p>
            <p>
              <strong>9.12</strong> The Company shall not use personal information of customers for marketing
              purposes by any entity including self, unless authorized by the customer.
            </p>
          </div>

          <h3>10. Validity</h3>
          <div className="about-us-content">
            <p>
              The Policy shall be valid until the revision of the policy by the Board or Committee, if any.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}

export default FairPracticeCode;



// WEBPACK FOOTER //
// ./src/components/FairPracticeCode.js